export enum ShipToType {
  Emergency = "Emergency",
  Customer = "Customer",
  Account = "Account",
}
